var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoatBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 615,
    viewBox: "0 0 313 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 220.5H156.5H312.5V614.5H0.5V220.5Z",
    fill: "white",
    stroke: "#E0E8E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 220C0 196.212 8.49108 173.205 23.9449 155.12L122.115 40.2382C140.17 19.11 172.83 19.1099 190.885 40.2381L289.055 155.12C304.509 173.205 313 196.212 313 220H156.5H0Z",
    fill: "#E0E8E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatBackground);
export default __webpack_public_path__ + "static/media/boat_background.8187ffa7a556b12e9d0b26a55ceee78a.svg";
export { ForwardRef as ReactComponent };